var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "container", attrs: { type: "flex" } },
        [
          _c("h3", { staticClass: "title" }, [_vm._v("Filtros")]),
          _c(
            "el-row",
            { staticClass: "filter-row" },
            [
              _c(
                "el-col",
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Município:")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        multiple: "multiple",
                        name: "municipio"
                      },
                      model: {
                        value: _vm.dados.municipios,
                        callback: function($$v) {
                          _vm.$set(_vm.dados, "municipios", $$v)
                        },
                        expression: "dados.municipios"
                      }
                    },
                    _vm._l(_vm.municipios, function(item) {
                      return _c("el-option", {
                        key: item.nome,
                        attrs: { label: item.nome, value: item.nome }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v("Data de cadastro:")
                  ]),
                  _c("el-date-picker", {
                    staticClass: "full-width input date",
                    style: { width: "inherit" },
                    attrs: {
                      type: "daterange",
                      "start-placeholder": "Data inicial",
                      "end-placeholder": "Data Final",
                      format: "dd/MM/yyyy",
                      name: "dataCadastro"
                    },
                    model: {
                      value: _vm.dados.periodo,
                      callback: function($$v) {
                        _vm.$set(_vm.dados, "periodo", $$v)
                      },
                      expression: "dados.periodo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Situação:")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        name: "status",
                        "collapse-tags": "collapse-tags"
                      },
                      model: {
                        value: _vm.dados.status,
                        callback: function($$v) {
                          _vm.$set(_vm.dados, "status", $$v)
                        },
                        expression: "dados.status"
                      }
                    },
                    _vm._l(_vm.situacao, function(item) {
                      return _c("el-option", {
                        key: item.nome,
                        attrs: { label: item.nome, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "filter-row" },
            [
              _c(
                "el-col",
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Perfil:")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        name: "perfil",
                        "collapse-tags": "collapse-tags"
                      },
                      model: {
                        value: _vm.dados.perfil,
                        callback: function($$v) {
                          _vm.$set(_vm.dados, "perfil", $$v)
                        },
                        expression: "dados.perfil"
                      }
                    },
                    _vm._l(_vm.perfis, function(item) {
                      return _c("el-option", {
                        key: item.codigo,
                        attrs: { label: item.nome, value: item.codigo }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Setor:")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        name: "setor",
                        "collapse-tags": "collapse-tags"
                      },
                      model: {
                        value: _vm.dados.setor,
                        callback: function($$v) {
                          _vm.$set(_vm.dados, "setor", $$v)
                        },
                        expression: "dados.setor"
                      }
                    },
                    _vm._l(_vm.setores, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  style: [
                    _vm.showNumeroProcesso
                      ? { visibility: "visible" }
                      : { visibility: "hidden" }
                  ]
                },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v("Número do processo")
                  ]),
                  _c("el-input", {
                    model: {
                      value: _vm.dados.numeroProcesso,
                      callback: function($$v) {
                        _vm.$set(_vm.dados, "numeroProcesso", $$v)
                      },
                      expression: "dados.numeroProcesso"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "button-row" },
            [
              _c("span", { staticClass: "limpar", on: { click: _vm.limpar } }, [
                _vm._v("Limpar")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.filtrar } },
                [_vm._v("Filtrar")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f4e1f28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f4e1f28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/relatorios/components/FiltroRelatorios.vue
// module id = null
// module chunks = 